module.exports = __webpack_public_path__ + "assets/img/icon_service11.226339a3.png";